module.exports = __webpack_public_path__ + "static/media/difc.bea4905c.jpg";